<template>
  <div class="org-dialog">
    <el-input v-model="searchVal" class="input" autofocus placeholder="请输入内容" clearable @keydown.enter.native="querySelice" @clear="showTable = false" @change="changeInput">
      <el-button slot="append" icon="el-icon-search" @click="querySelice" />
    </el-input>
    <div class="content-box">
      <el-tree
        v-show="!showTable"
        ref="tree"
        class="filter-tree"
        show-checkbox
        :props="defaultProps"
        :load="loadTreeNode"
        :check-on-click-node="true"
        :check-strictly="true"
        node-key="id"
        lazy
        @check="treeCheck"
      />
      <template v-if="showTable">
        <TableCommon
          :show-header="false"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
        >
          <vxe-grid
            ref="gridOptions"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            max-height="400"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{name: 'NotData'}"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            @cell-dblclick="cellClick"
          />
        </TableCommon>
      </template>

    </div>

  </div>
</template>
<script>
import { apiQueryOrg, apiSlicedQueryOrgs } from '@/api/common'
export default {
  props: {
    isRadio: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchVal: '',
      showTable: false,
      checkedboxEmployee: {},
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'radio', title: '', field: 'radio', width: 40 },
          { field: 'code', title: '账号', width: 120 },
          { field: 'longName', title: '名称', width: 120 },
          { field: 'fullName', title: '路径' }
        ],
        data: []
      },
      rootNode: [],
      params: {
        parentId: 'orgRoot'
      }
    }
  },
  watch: {
  },
  created() {
    if (!this.isRadio) {
      this.gridOptions.columns[0].type = 'checkbox'
    }
  },
  mounted() {

  },
  methods: {
    cellClick({ row }) {
      this.$refs.gridOptions.setRadioRow(row)
    },
    treeCheck(node, list) {
      if (list.checkedKeys.length === 2) {
        this.checkedboxEmployee = node
        this.$refs.tree.setCheckedKeys([node.id])
      } else {
        this.checkedboxEmployee = node
      }
    },
    changeInput(e) {
      if (!e) {
        this.showTable = false
      }
    },
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      this.querySelice()
    },
    async queryOrgs(node = { level: 0 }) {
      if (node.level === 0) {
        this.params.parentId = 'orgRoot'
      } else {
        this.params.parentId = node.data.id
      }
      const res = await apiQueryOrg(this.params)
      if (res?.status === 0 && res.data.Total > 0) {
        if (node.level === 0) {
          this.rootNode = res.data.Rows.filter(item => {
            return item.parentId === 'orgRoot' && item.orgCode === 'WLY'
          })
        } else {
          this.rootNode = res.data.Rows
        }
        return Promise.resolve(this.rootNode)
      }
    },
    async querySelice() {
      if (!this.searchVal) return
      const res = await apiSlicedQueryOrgs({ ...this.pagination, paramValue: this.searchVal })
      this.gridOptions.data = res.data.Rows
      this.pagination.totalCount = res.data.Total
      this.showTable = true
    },
    async loadTreeNode(node, resolve) {
      const data = await this.queryOrgs(node)
      if (data) {
        data.map(item => {
          if (item.hasChildren === 0) {
            item.leaf = false
          }
        })
        resolve(data)
      } else {
        resolve([])
      }
    },
    // 用于弹窗提交时 回调数据
    submitForm() {
      // 给父组件返回promise对象用于回调
      return new Promise(resolve => {
        if (this.showTable) {
          resolve(this.$refs.gridOptions.getRadioRecord() || undefined)
        } else {
          resolve(this.checkedboxEmployee)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.input {
  margin-bottom: 15px;
}
.content-box {
  height: 450px;
  background: #fff;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/StaffSelect.vue